import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { ExcelExportColumn } from "../models/ExcelExport";
import { ToolColumn } from "../models/ToolColumn";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class ToolGridService {
  constructor(
    private translateService: TranslateService,
    private storageService: StorageService,
  ) {}

  private restoreColumns(): ToolColumn[] {
    return this.storageService.getToolColumns();
  }

  saveColumns(toolsDropColumnState: ToolColumn[]): void {
    this.storageService.setToolColumns(toolsDropColumnState);
  }

  getStoredColumns(): ToolColumn[] {
    let dropColumnState = this.restoreColumns();

    if (!dropColumnState) {
      dropColumnState = this.getDefaultColumns();
      this.saveColumns(dropColumnState);
    }

    return dropColumnState;
  }

  private getDefaultColumns(): ToolColumn[] {
    return [
      // ToolId and the serial number are exchanged intentionally
      new ToolColumn("serialNumber", "tool.toolid", true, "serialNumber", true),
      new ToolColumn("modelNumber", "tool.modelnumber", true),
      new ToolColumn("subtype", "tool.subtype", true),
      new ToolColumn("serviceDueDate", "tool.nextservice", true, "serviceDueDate"),
    ];
  }

  getAllColumns(): ToolColumn[] {
    return [
      // ToolId and the serial number are exchanged intentionally
      new ToolColumn("serialNumber", "tool.toolid", true, "serialNumber", true),
      new ToolColumn("toolId", "tool.serialnumber", false, "toolId", true),
      new ToolColumn("modelNumber", "tool.modelnumber", true),
      new ToolColumn("subtype", "tool.subtype", true),
      new ToolColumn("serviceDueDate", "tool.nextservice", true, "serviceDueDate"),
      new ToolColumn("dueDate", "tool.nextcalibration", false, "dueDate"),
      new ToolColumn("numberOfServices", "tool.numberofservice"),
      new ToolColumn("numberOfServicesTwelveMonths", "tool.numberofservicelastyear"),
      new ToolColumn("totalCycles", "tool.totalcycles"),
      new ToolColumn("contracts", "tool.contracts", false, "contracts", false, false),
      new ToolColumn("companyId", "tool.company"),
      new ToolColumn("manufacturer", "tool.manufacturer"),
      new ToolColumn("eventStatus", "tool.status", false, "eventStatus"),
      new ToolColumn("isActive", "tool.active", false, "boolean"),
      new ToolColumn("worktype", "tool.worktype", false, "worktype"),
      new ToolColumn("locationName", "tool.location"),
      new ToolColumn("locationDescription", "tool.locationdescription"),
      new ToolColumn("lastCalibrationDate", "tool.lastcalibration", false, "date"),
      new ToolColumn("calibrationNumber", "tool.calibrationnumber"),
      new ToolColumn("poNumber", "tool.ponumber"),
      new ToolColumn("raNumber", "tool.ranumber"),
      new ToolColumn("jobNumber", "tool.jobnumber"),
      new ToolColumn("serviceLastDate", "tool.lastservice", false, "date"),
      new ToolColumn("lastModifiedDate", "tool.lastmodifieddate", false, "date"),
    ];
  }
  public async getAllColumnsForExcelExport(): Promise<ExcelExportColumn[]> {
    const columns = this.getAllColumns();
    const exportColumns: ExcelExportColumn[] = [];

    columns.forEach(async (x) => {
      const translation = await this.translateService.get(x.headerTitle).toPromise();
      const col = new ExcelExportColumn(x.field, translation);
      exportColumns.push(col);
    });

    return exportColumns;
  }
}
